module.exports = function preparePostInitFunction(options, instead) {


  // presunuti blokyu poslednich vyhledavani nakonec pod submit
  window.ybusPostRenderFunction = function(self) {
    $(self.find('.form-submit')).after(self.find('#ybus-saved_routes-block'))
  }

  function sharedFunction (component, context) {
    if (!Modernizr.touch) {

      context.find('select').each(function(){
        //Označovanie vybraného prvku v selectu robilo problémy
        //Vyberiem hodnotu označeného optionu (s atribútom selected)
        var selectedValue = $(this).find('option[selected="selected"]').val();
        var sel = new Select({
            el: this,
            alignToHighlighted: 'always'
        });

        //Zmením hodnotu nového selectu podľa predtým uloženej
        if(selectedValue)
          sel.change(selectedValue);
      });

      //Natvrdo intervalu označím prvý option. Označoval sa tretí
      var int_option = $('#search_interval option[selected="selected"]');
      if(int_option)
        int_option.attr("selected",true);
    }
    else {
      context.find('select').each(function(){
        $(this).selectTouch();
      });
    }
  }

  // postInitHook funkce pro letenky
  function letenky (component, context) {
    var opts = context.data('opts');

    // presun ulozenych cest pod submit
    $(`.${opts.name} .form-submit`).after($(`.${opts.name} #airticket-saved_routes-block`))

    sharedFunction(component, context);

    window.airSelectPostRenderFunction = function() {
      sharedFunction(null, $('#airticket-airline-block'));
    }

    function getIntervalSelect() {
      var instance = null;
      $('#form-1').find('select#search_interval').each(function() {
        instance = this.selectInstance;
      });
      return instance;
    }

    //WEB-3369 defaultné hodnoty intervalu
    window.airticketActivateFormCustom = {
      oneway () {
        var instance = getIntervalSelect();
        if(instance)
          instance.change(String($('#oneway').data('search_interval')));
      },
      round_trip () {
        var instance = getIntervalSelect();
        if(instance)
          instance.change(String($('#round_trip').data('search_interval')));
      },
      open_jaw () {
        var instance = getIntervalSelect();
        if(instance)
          instance.change(String($('#open_jaw').data('search_interval')));
      }
    };
  }


  // sestaveni objektu s postInitFunkci
  var postInit = {
    letenky: {
      postInitHook: letenky
    },
    jizdenky: {
      postInitHook: sharedFunction
    },
    ubytovani: {
      postInitHook: sharedFunction
    },
    pojisteni: {
      postInitHook: sharedFunction
    },
    auta: {
      postInitHook: sharedFunction
    },
    jazykovePobyty: {
      postInitHook: sharedFunction
    },
    pracovniPobyty: {
      postInitHook: sharedFunction
    },
    dovolena: {
      postInitHook: sharedFunction
    }
  };

  Object.keys(options).forEach((key) => {
    if (instead.length !== 0) {
      if (jQuery.inArray(key, instead) !== 0)
        options[key] = $.extend({}, options[key], postInit[key]);
    } else {
      options[key] = $.extend({}, options[key], postInit[key]);
    }
  });

  return options;

};



// WEBPACK FOOTER //
// ./src/js/global/preparePostInitHookFunction.js